const SCROLL_INDICATOR_SELECTOR = '.scroll-indicator';
const POST_CONTENT_SELECTOR = '.post-content';

const handleScroll = (postContent: HTMLElement, scrollIndicator: HTMLElement) => {
  const postContentHeight = postContent.scrollHeight;
  const postContentOffset = postContent.offsetTop;
  const postContentBottom = postContentOffset + postContentHeight - window.innerHeight;

  const percentage = window.scrollY / postContentBottom;
  const scrollPercentage = Math.min(1, Math.max(0, percentage));
  scrollIndicator.style.transform = `scaleX(${scrollPercentage})`;
};

export function setupScrollIndicator() {
  const scrollIndicator: HTMLElement | null = document.querySelector(SCROLL_INDICATOR_SELECTOR);
  const postContent: HTMLElement | null = document.querySelector(POST_CONTENT_SELECTOR);

  if (!scrollIndicator || !postContent) {
    return;
  }

  const throttledHandleScroll = () => requestAnimationFrame(() => handleScroll(postContent, scrollIndicator));
  throttledHandleScroll();
  window.addEventListener('scroll', throttledHandleScroll);
}